import { useQuery } from '@tanstack/react-query';
import { configApi } from '../../configApi';

export interface IDefenseStep {
  id: string;
  selective_process: string;
  step: string;
  name: string;
  description: string;
  status: string;
  submission_start: string;
  submission_end: string;
  defense_date: string | null;
  max_files_per_candidate: number;
  max_file_size_mb: number;
  max_total_size_mb: number;
  allowed_extensions: string[];
  allow_edit_metadata: boolean;
  allow_file_replacement: boolean;
  allow_file_deletion: boolean;
  allow_file_restoration: boolean;
  enable_preview: boolean;
  preview_formats: string[];
  enable_bulk_download: boolean;
  enable_antivirus_scan: boolean;
  quarantine_on_virus: boolean;
  retention_days: number;
  reopening_count: number;
  is_active: boolean;
  can_submit: boolean;
  can_edit: boolean;
  can_replace: boolean;
  can_delete: boolean;
  can_restore: boolean;
  submissions_count: number;
  created_at: string;
  updated_at: string;
}

interface IDefenseStepResponse {
  count: number;
  next: string | null;
  previous: string | null;
  results: IDefenseStep[];
}

const getDefenseStep = async (stepId: string): Promise<IDefenseStep | null> => {
  const response = await configApi.get<IDefenseStepResponse>(
    '/research-proposal-defense/steps/',
    {
      params: {
        step: stepId,
      },
    }
  );
  
  // Retorna o primeiro resultado ou null se não encontrar
  if (response.data.results && response.data.results.length > 0) {
    return response.data.results[0];
  }
  
  return null;
};

export const useGetDefenseStep = (stepId: string) => {
  return useQuery({
    queryKey: ['defense_step', stepId],
    queryFn: () => getDefenseStep(stepId),
    enabled: !!stepId,
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 10, // 10 minutos
    retry: 2,
  });
};
